import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import Axios from 'axios'
import { VLazyImagePlugin } from "v-lazy-image";

import './styles.sass'

Vue.config.productionTip = false

Vue.use(VueAxios, Axios)
Vue.use(VLazyImagePlugin)

Vue.axios.defaults.baseURL = 'https://api.gxsv.fcs.la/'
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
